/**
 * @module geo
 *
 */
import { Application, createApplication, createApplicationAsync } from "./geo";

import { Observable, operators } from 'rxjs';

const rxjs = {
  Observable,
  operators
}

const geo = {
  createApplication,
  createApplicationAsync,
  application: createApplicationAsync,
  Application,
  rxjs
};

export { geo, geo as geoApi };
